import { Badge } from '@givebutter/primitives/badge';
import { collectionNameToReadable } from 'components/search/transform';
import { useSearchStore } from 'components/search/useSearchStore';

const SearchFilterBadges = () => {
    const { resourceFilter, removeResourceFilter } = useSearchStore();

    if (resourceFilter.length === 0) {
        return null;
    }

    return (
        <div className={'flex flex-wrap gap-1.5 px-2'}>
            {resourceFilter.map(resource => (
                <Badge
                    key={resource}
                    variant="rounded"
                    onClose={() => removeResourceFilter(resource)}
                >
                    {collectionNameToReadable(resource)}
                </Badge>
            ))}
        </div>
    );
};

export { SearchFilterBadges };
